// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"830":"ae49968a","881":"4f58fb59"}[chunkId] + ".chunk.css";
};